import { Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { GetProductRealTimeInventoryApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import { chain, FindWarehouseData  } from "@insite/client-framework/Store/Data/RealTimeInventory/Handlers/GetRealTimeWarehouseInventory";
import { ProductInventoryDto, WarehouseDto } from "@insite/client-framework/Types/ApiModels";

// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

interface Result {
    errorMessage: string;
    warehouses?: WarehouseDto[];
    inventory?: ProductInventoryDto;
}

type HandlerType = Handler<
    GetProductRealTimeInventoryApiV2Parameter & {
        /** This is a legacy onComplete, it will only fire if the Handler CallOnComplete is hit */
        onComplete: (result: Result) => void;
        unitOfMeasure: string;
    },
    {
        apiParameter: GetProductRealTimeInventoryApiV2Parameter;
        apiResult?: ProductInventoryDto;
        result: Result;
    }
>;


export const FindWarehouseDataOverRide: HandlerType = props => {
    props.result = {
        errorMessage: "Inventory is not currently available",
    };

    if (props.apiResult && props.apiResult.inventoryWarehousesDtos) {
        const inventoryWarehousesDto = props.apiResult.inventoryWarehousesDtos.find(
            o => o.unitOfMeasure.toLowerCase() === props.parameter.unitOfMeasure.toLowerCase(),
        );

        if (inventoryWarehousesDto && inventoryWarehousesDto.warehouseDtos) {
            props.result = {
                inventory: props.apiResult,
                warehouses: inventoryWarehousesDto.warehouseDtos,
                errorMessage: "",
            };
        }
    }
};

replaceInChain(chain, FindWarehouseData, FindWarehouseDataOverRide);

